import { useTranslation } from 'react-i18next';
import Iconify from 'src/components/Iconify';
import { DIRECIONAMENTOS_COMPONENT_DESIGN as D } from './DirecionamentosComponent.design';

export default function TableDirecionamentos({ data, onEdit, onDelete }) {
  const { t } = useTranslation('settings');

  if (!data || data.length === 0) return null;

  return (
    <div className={D.tableWrap}>
      <div className={D.tableHeadRow}>
        <div className={`flex-1 min-w-[160px] pr-4 ${D.tableHead}`}>{t('targeting.table.headRecebe', 'Recebe')}</div>
        <div className={`flex-1 hidden md:block pr-4 ${D.tableHead}`}>{t('targeting.table.headSetores', 'Setores')}</div>
        <div className={`flex-1 hidden md:block pr-4 ${D.tableHead}`}>{t('targeting.table.headUsuarios', 'Usuários')}</div>
        <div className={`w-24 text-right ${D.tableHead}`}>{t('buttons.actions', { ns: 'common' })}</div>
      </div>
      {data.map((row) => (
        <div key={row._id} className={D.tableRow}>
          <div className={`flex-1 min-w-[160px] pr-4 ${D.tableCell} font-semibold truncate`}>{row.recebe}</div>
          <div className="flex-1 hidden md:flex flex-wrap gap-1 pr-4">
            {row.setores?.map((setor, idx) => (
              <span key={idx} className={D.badge}>{setor.nome_setor}</span>
            ))}
          </div>
          <div className="flex-1 hidden md:flex flex-wrap gap-1 pr-4">
            {row.usuarios?.map((user, idx) => (
              <span key={idx} className={D.badge}>{user.nomeFantasia}</span>
            ))}
          </div>
          <div className="w-24 flex justify-end gap-1.5">
            <button type="button" title={t('buttons.edit', { ns: 'common' })} onClick={() => onEdit(row)} className={D.iconButton}>
              <Iconify icon="eva:edit-2-outline" width={16} />
            </button>
            <button type="button" title={t('buttons.delete', { ns: 'common' })} onClick={() => onDelete(row)} className={D.iconButtonDanger}>
              <Iconify icon="eva:trash-2-outline" width={16} />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
